import React from 'react';
import { Container } from '../components/ui/Container';
export function EULAPage() {
  return <div className="bg-white py-20 lg:py-28" data-id="element-311">
      <Container size="md" data-id="element-312">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl mb-8" data-id="element-313">
          End User License Agreement
        </h1>
        <p className="text-gray-500 mb-12" data-id="element-314">Last updated: June 1, 2024</p>

        <div className="prose prose-lg prose-indigo max-w-none" data-id="element-315">
          <p data-id="element-316">
            This End User License Agreement ("Agreement") is a legal agreement
            between you ("User") and Flowsense Inc. ("Company") for the use of
            the Flowsense software platform ("Software").
          </p>

          <h2 data-id="element-317">1. License Grant</h2>
          <p data-id="element-318">
            Subject to the terms of this Agreement, Company grants you a
            limited, non-exclusive, non-transferable, revocable license to use
            the Software for your internal business purposes in accordance with
            the documentation provided by Company.
          </p>

          <h2 data-id="element-319">2. Restrictions</h2>
          <p data-id="element-320">You shall not:</p>
          <ul data-id="element-321">
            <li data-id="element-322">
              Modify, translate, adapt, or otherwise create derivative works or
              improvements, whether or not patentable, of the Software.
            </li>
            <li data-id="element-323">
              Reverse engineer, disassemble, decompile, decode, or otherwise
              attempt to derive or gain access to the source code of the
              Software.
            </li>
            <li data-id="element-324">
              Remove, delete, alter, or obscure any trademarks or any copyright,
              trademark, patent, or other intellectual property or proprietary
              rights notices from the Software.
            </li>
            <li data-id="element-325">
              Rent, lease, lend, sell, sublicense, assign, distribute, publish,
              transfer, or otherwise make available the Software to any third
              party.
            </li>
          </ul>

          <h2 data-id="element-326">3. Ownership</h2>
          <p data-id="element-327">
            You acknowledge and agree that the Software is provided under
            license, and not sold, to you. You do not acquire any ownership
            interest in the Software under this Agreement, or any other rights
            thereto other than to use the Software in accordance with the
            license granted, and subject to all terms, conditions, and
            restrictions, under this Agreement.
          </p>

          <h2 data-id="element-328">4. Updates</h2>
          <p data-id="element-329">
            Company may from time to time in its sole discretion develop and
            provide Software updates, which may include upgrades, bug fixes,
            patches, other error corrections, and/or new features. You agree
            that Company has no obligation to provide any updates or to continue
            to provide or enable any particular features or functionality.
          </p>

          <h2 data-id="element-330">5. Warranty Disclaimer</h2>
          <p data-id="element-331">
            THE SOFTWARE IS PROVIDED TO LICENSEE "AS IS" AND WITH ALL FAULTS AND
            DEFECTS WITHOUT WARRANTY OF ANY KIND. TO THE MAXIMUM EXTENT
            PERMITTED UNDER APPLICABLE LAW, COMPANY EXPRESSLY DISCLAIMS ALL
            WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE.
          </p>

          <h2 data-id="element-332">6. Limitation of Liability</h2>
          <p data-id="element-333">
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL
            COMPANY BE LIABLE FOR ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
            CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR
            USE OF OR INABILITY TO USE THE SOFTWARE.
          </p>

          <h2 data-id="element-334">7. Termination</h2>
          <p data-id="element-335">
            This Agreement is effective until terminated. Company may terminate
            this Agreement at any time without notice if it ceases to support
            the Software, which Company may do in its sole discretion. In
            addition, this Agreement will terminate immediately and
            automatically without any notice if you violate any of the terms and
            conditions of this Agreement.
          </p>
        </div>
      </Container>
    </div>;
}